<template>
    <div>
        <vx-card class="mb-3">
            <div class="flex">
                <div class="float-left">
                    {{ object_data.Code }}
                </div>
            </div>
        </vx-card>

        <div class="vx-row">
            <div class="vx-col w-3/5">
                <vx-card>
                    <ObjectForm ref="object_form" :object_name="object_name" :method="'update'" :object_id="object_id"
                        @getObjectData="getObjectData" />
                </vx-card>
            </div>
            <div class="vx-col w-2/5" id="status-update-section">
                <vx-card title="Status Update" class="mb-3">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-3">
                            <small class="label">Change To</small>
                            <v-select :clearable="true" v-model="status_change_form.status"
                                :reduce="option => option.value" :options="action_status_list" label="key"
                                class="w-full">
                            </v-select>
                        </div>
                        <div class="vx-col w-full mb-3">
                            <small class="label">Comment</small>
                            <vs-textarea v-model="status_change_form.comments" rows="2" class="w-full" />
                        </div>
                        <div class="vx-col w-full mb-3">
                            <small class="label">Due Date</small>
                            <flat-pickr v-model="status_change_form.DueDate" placeholder="" class="w-full" />
                        </div>
                        <div class="vx-col w-full mb-3">
                            <vs-button @click.stop="onClickUpdateStatus()" class="w-full"
                                :disabled="!status_change_form.status"> Save</vs-button>
                        </div>
                    </div>

                </vx-card>
                <vx-card title="Status Timeline">
                    <div class="flex mb-3">
                        <vs-button v-if="is_on_status_log_update" @click.stop="is_on_status_log_update = !is_on_status_log_update" size="small" class="mr-auto ml-0"
                            color="warning" type="border" icon-pack="feather" icon="icon-arrow-left">Go Back to Timeline View</vs-button>
                        <vs-button v-if="!is_on_status_log_update" @click.stop="onClickManageActionStatuslog()" size="small" class="ml-auto mr-0"
                            color="primary" type="filled" icon-pack="feather" icon="icon-edit">Update/Delete Status Logs</vs-button>
                    </div>
                    <vx-timeline v-if="!is_on_status_log_update" :data="timelineData"></vx-timeline>
                    <div class="vx-row text-sm" v-if="is_on_status_log_update">
                        <div class="vx-col w-full">
                            <vs-table :data="status_logs">

                                <template slot="thead">
                                    <vs-th width="10%">Created At</vs-th>
                                    <vs-th width="10%">Status Changed To</vs-th>
                                    <vs-th width="65%">Comments</vs-th>
                                    <vs-th width="15%"></vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                        <vs-td :data="data[indextr].createdAt">
                                            {{ __dateTimeFormatterToDate(data[indextr].createdAt) }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].status">
                                            {{ data[indextr].status }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].comments">
                                            {{ data[indextr].comments }}
                                        </vs-td>

                                        <vs-td>
                                            <div class="vx-row">
                                                <vx-tooltip class="mr-2" text="Update" position="top">
                                                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small"
                                                        color="primary" type="border" icon-pack="feather"
                                                        icon="icon-eye"></vs-button>
                                                </vx-tooltip>
                                                <vx-tooltip class="mr-2" text="Delete" position="top">
                                                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)"
                                                        size="small" color="danger" type="border" icon-pack="feather"
                                                        icon="icon-trash-2"></vs-button>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                </template>

                            </vs-table>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <UpdateActionStatusLogPopUp ref="updateActionStatusLogPopUp"/>
    </div>
</template>
<script>
import ObjectForm from "@/components/shared/Forms/ObjectForm.vue"
import VxTimeline from "@/components/timeline/VxTimeline.vue"
import vSelect from 'vue-select'
import UpdateActionStatusLogPopUp from '@/components/popups/assessment-actions/UpdateActionStatusLogPopUp.vue'

import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ActionRepository = RepositoryFactory.get('action');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const statusMappings = {
    "New": { color: "primary", icon: "PlusIcon" },
    "Complete": { color: "primary", icon: "CheckCircleIcon" },
    "In Progress": { color: "warning", icon: "RefreshCwIcon" },
    "Outstanding": { color: "danger", icon: "AlertCircleIcon" },
    "Not Accepted": { color: "danger", icon: "XIcon" }
};

export default {
    name: "ActionView",
    data() {
        return {
            object_name: 'action',
            object_id: this.$route.params.id,
            object_data: {},
            action_status_list: [
                { key: 'In Progress', value: 'In Progress' },
                { key: 'Complete', value: 'Complete' },
                { key: 'Outstanding', value: 'Outstanding' },
                { key: 'Not Accepted', value: 'Not Accepted' }
            ],
            timelineData: [],
            change_status: null,
            status_change_form: {
                status: '',
                comments: '',
                DueDate: ''
            },
            is_on_status_log_update: false,
            status_logs: []
        }
    },
    components: {
        ObjectForm,
        VxTimeline,
        'v-select': vSelect,
        flatPickr,
        UpdateActionStatusLogPopUp
    },
    methods: {
        async refreshData() {
            await this.fetchActionStatuslog()
        },
        async getAction() {
            await this.$store.dispatch('action/get', this.$route.params.id)
        },
        getObjectData(data) {
            this.object_data = data
        },
        async fetchActionStatuslog() {
            try {
                const { data } = (await ActionRepository.fetchActionStatusLogs(this.object_name, this.object_id)).data
                this.status_logs = data
                this.timelineData = data.map((x) => {
                    const { color, icon } = statusMappings[x.status] || { color: "info", icon: "HelpCircleIcon" };
                    return {
                        color,
                        icon,
                        title: x.status,
                        desc: x.comments,
                        time: `${x.time} - ${this.__dateTimeFormatter(x.createdAt)}`,
                        id: x._id
                    };
                });
            } catch (error) {

            }
        },
        async onClickUpdateStatus() {
            await this.$vs.loading({
                container: '#status-update-section',
                scale: 0.45
            })
            try {
                await ActionRepository.updateActionStatus(this.object_name, this.object_id, this.status_change_form)
                await this.fetchActionStatuslog()
                this.status_change_form = {
                    status: '',
                    comments: '',
                    DueDate: ''
                }
                await this.$refs.object_form.fetchObjectDetailsData()
            } catch (error) {

            } finally {
                this.$vs.loading.close('#status-update-section > .con-vs-loading')
            }
        },
        async onClickManageActionStatuslog() {
            console.log(this.timelineData)
            this.is_on_status_log_update = true
        },
        async onClickDeleteConfirm(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm',
                acceptText: 'Delete',
                text: `Are you sure you want to delete this action log?`,
                accept: this.onClickDelete,
                parameters: [id]
            })
        },
        async onClickDelete(params) {
            await this.$vs.loading({
                container: '#status-update-section',
                scale: 0.50
            });
            try {
                await ActionRepository.deleteActionStatuslog(this.object_id, params[0])
                await this.refreshData()
            } catch (e) {
                console.log(e)
            }
            await this.$vs.loading.close('#status-update-section > .con-vs-loading')
        },
        async onClickUpdate(data) {
            await this.$refs.updateActionStatusLogPopUp.openPopup(this.object_id, data)
        }
    },
    async mounted() {
        await this.fetchActionStatuslog()
    }
}
</script>
<style lang="">

</style>